export type Category = 'all' | 'geometry' | 'fractions' | 'arithmetic' | 'financial'

export interface CalcMeta {
  id: string
  title: string
  short: string
  category: Exclude<Category, 'all'>
  volume: string
  keywords: string[]
}

export const CALCULATORS: CalcMeta[] = [
  {
    id: 'circle',
    title: 'Circle Circumference Formula Calculator',
    short: 'Circle Circumference',
    category: 'geometry',
    volume: '33,100/mo',
    keywords: ['circle', 'circumference', 'radius', 'diameter', 'pi', 'perimeter'],
  },
  {
    id: 'fraction',
    title: 'Mixed Fraction Calculator with Whole Numbers',
    short: 'Mixed Fractions',
    category: 'fractions',
    volume: '22,200/mo',
    keywords: ['fraction', 'mixed', 'numerator', 'denominator', 'add', 'subtract', 'multiply', 'divide'],
  },
  {
    id: 'trapezoid',
    title: 'Trapezoid Area Formula Calculator',
    short: 'Trapezoid Area',
    category: 'geometry',
    volume: '22,200/mo',
    keywords: ['trapezoid', 'area', 'base', 'height', 'midsegment', 'geometry'],
  },
  {
    id: 'interest',
    title: 'Simple Interest Equation Calculator',
    short: 'Simple Interest',
    category: 'financial',
    volume: '22,200/mo',
    keywords: ['interest', 'principal', 'rate', 'time', 'finance', 'I=Prt', 'money'],
  },
  {
    id: 'rounding',
    title: 'Rounding Numbers & Snapping Calculator',
    short: 'Rounding Numbers',
    category: 'arithmetic',
    volume: '18,100/mo',
    keywords: ['rounding', 'round', 'nearest', 'snapping', 'decimal', 'integer'],
  },
]

export const CATEGORIES: { id: Category, label: string }[] = [
  { id: 'all', label: 'All Solvers' },
  { id: 'geometry', label: 'Geometry & Angles' },
  { id: 'fractions', label: 'Fractions & Decimals' },
  { id: 'arithmetic', label: 'Arithmetic Basics' },
  { id: 'financial', label: 'Financial Math' },
]

export function gcd(a: number, b: number): number {
  a = Math.abs(Math.trunc(a))
  b = Math.abs(Math.trunc(b))
  while (b) { [a, b] = [b, a % b] }
  return a || 1
}

export function copyMarkdown(text: string): Promise<void> {
  if (navigator.clipboard?.writeText) return navigator.clipboard.writeText(text)
  return new Promise((resolve) => {
    const ta = document.createElement('textarea')
    ta.value = text
    document.body.appendChild(ta)
    ta.select()
    document.execCommand('copy')
    document.body.removeChild(ta)
    resolve()
  })
}
